/**
 * Maximum duration a single lesson/audio file is allowed to have (in minutes).
 *
 * Used in:
 * - CMS ingestion (reject overly long uploads; compare against {@link MAX_LESSON_DURATION_SECONDS})
 * - Gamification validation (cap actively played minutes per session)
 */
export const MAX_LESSON_DURATION_MINUTES = 240;

/** CMS `duration` is stored in seconds (`HTMLAudioElement.duration`). */
export const MAX_LESSON_DURATION_SECONDS = MAX_LESSON_DURATION_MINUTES * 60;

/** Minimum selectable silent meditation duration (in minutes). */
export const MIN_SILENT_MEDITATION_DURATION_MINUTES = 1;

/** Maximum selectable silent meditation duration (in minutes). */
export const MAX_SILENT_MEDITATION_DURATION_MINUTES = 60;

/**
 * Sentinel `mediaId` for `recordSessionComplete` when `mediaType` is silent meditation
 * (no CMS document). Activity-log entries still omit `mediaId`.
 */
export const SILENT_MEDITATION_MEDIA_ID = "silent-meditation";
